"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DateField = void 0;
const react_1 = __importStar(require("react"));
const clsx_1 = __importDefault(require("clsx"));
const date_fns_1 = __importDefault(require("@date-io/date-fns"));
const date_fns_2 = require("date-fns");
const locale_context_1 = require("../../common/locale/locale-context");
const MuiPickersUtilsProvider_1 = __importDefault(require("@material-ui/pickers/MuiPickersUtilsProvider"));
const DatePicker_1 = require("@material-ui/pickers/DatePicker");
const event_callback_hook_1 = require("../../utils/event-callback-hook");
const date_utils_1 = require("../../utils/date-utils");
const date_field_styles_1 = require("./date-field-styles");
const react_intl_1 = require("react-intl");
/**
 * @deprecated
 *
 * Use LocalDateField instead.
 */
function DateField({ form, disabled, minDate: minDateString, maxDate: maxDateString, minDatePicker: minDatePickerString = minDateString, maxDatePicker: maxDatePickerString = maxDateString, value, onChange, representation = 'local-date', }) {
    // fix undefined value
    value = value !== null && value !== void 0 ? value : null;
    const intl = react_intl_1.useIntl();
    const { locale } = react_1.useContext(locale_context_1.LocaleContext);
    const [internalValue, setInternalValue] = react_1.useState(() => date_utils_1.parseISOSafe(value));
    const minDate = date_utils_1.parseISOSafe(minDateString);
    const maxDate = date_utils_1.parseISOSafe(maxDateString);
    const minDatePicker = date_utils_1.parseISOSafe(minDatePickerString);
    const maxDatePicker = date_utils_1.parseISOSafe(maxDatePickerString);
    const isError = event_callback_hook_1.useEventCallback((date) => {
        if (date != null) {
            if (!date_fns_2.isValid(date)) {
                return true;
            }
            else if (maxDate && date > maxDate) {
                return true;
            }
            else if (minDate && date < minDate) {
                return true;
            }
        }
        return false;
    });
    // update internal representation if supplied from above
    react_1.useEffect(() => setInternalValue(date_utils_1.parseISOSafe(value)), [value]);
    // stores the new value in internal storage and propagates above only null and valid dates
    const handleChange = event_callback_hook_1.useEventCallback((date) => {
        setInternalValue(date);
        if (date == null) {
            onChange(null);
        }
        else if (!isError(date)) {
            if (representation === 'local-date') {
                // example: 2021-07-23
                onChange(date_fns_2.format(date, 'yyyy-MM-dd'));
            }
            else if (representation === 'local-date-time') {
                // example: 2021-07-23T13:12:14
                onChange(date_fns_2.format(date, "yyyy-MM-dd'T'HH:mm:ss.SSS"));
            }
            else if (representation === 'instant') {
                // example: 2021-07-23T11:12:14.584Z
                onChange(date.toISOString());
            }
        }
    });
    const classes = date_field_styles_1.useStyles();
    return (react_1.default.createElement(MuiPickersUtilsProvider_1.default, { utils: date_fns_1.default, locale: locale.dateFnsLocale },
        react_1.default.createElement(DatePicker_1.KeyboardDatePicker, { InputProps: {
                classes: {
                    root: classes.root,
                    input: classes.input,
                },
            }, inputProps: {
                form,
            }, autoOk: true, variant: "dialog", fullWidth: true, disabled: disabled, value: internalValue, minDate: minDatePicker, maxDate: maxDatePicker, format: locale.dateFormat, onChange: handleChange, InputAdornmentProps: {
                classes: {
                    root: clsx_1.default({
                        [classes.addorment]: !disabled,
                        [classes.dissabledAddorment]: disabled,
                    }),
                },
            }, cancelLabel: intl.formatMessage({
                id: 'EAS_DATEPICKER_BUTTON_CANCEL',
                defaultMessage: 'Zrušit',
            }), okLabel: intl.formatMessage({
                id: 'EAS_DATEPICKER_BUTTON_OK',
                defaultMessage: 'Potvrdit',
            }), 
            // don't show error messages only error underline
            invalidDateMessage: "", maxDateMessage: "", minDateMessage: "", error: disabled ? false : isError(internalValue) })));
}
exports.DateField = DateField;
//# sourceMappingURL=date-field.js.map